export default __webpack_public_path__ + "static/media/02.dade7033.jpg";